import * as SQLite from 'expo-sqlite';
import {Platform} from 'react-native';

let db: SQLite.SQLiteDatabase;
const initDB = async () => {
  db = await SQLite.openDatabaseAsync('blobDB7');

  await db.execAsync(`
    DROP TABLE IF EXISTS blobs;
    CREATE TABLE IF NOT EXISTS blobs (id INTEGER PRIMARY KEY NOT NULL, data BLOB, parent VARCHAR);
  `);
};

Platform.OS !== 'web' && initDB();

export const createBlobDB = async () => {
  return {
    writeBlob: async (id: string, blob: Uint8Array) =>
      await db.runAsync(
        'INSERT INTO blobs (parent, data) VALUES (?, ?)',
        id,
        blob,
      ),
    readBlobs: async (id: string) => {
      const data = await db.getAllAsync(
        'SELECT * FROM blobs WHERE parent = ? ORDER BY id ASC limit 1000',
        [id],
      );
      const ids: number[] = data.map(i => i.id);
      const deletequery = `DELETE FROM blobs WHERE id IN (${ids.join(
        ',',
      )})`;
      // console.info('deletequery', deletequery)
      await db.runAsync(deletequery);
      return data;
    },
  };
};
